<ll-titulo>Editar Instrumento Predefinido #{{ instrumentoPredefinidoId }}</ll-titulo>
<ll-toolnavbar>
    <instrumento-predefinidos-toolnavbar
        [displayButtons]="'all'"
        [instrumentoPredefinidoId]="instrumentoPredefinidoId"
    ></instrumento-predefinidos-toolnavbar>
</ll-toolnavbar>

<instrumento-predefinido-edit [instrumentoPredefinidoId]="instrumentoPredefinidoId"></instrumento-predefinido-edit>
